import 'cross-fetch/polyfill'
import {
  ApolloClient,
  createHttpLink,
  InMemoryCache
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

// O zelas-bff nao valida Authorization (so CORS); o header so vai
// quando a chave existir, para nao quebrar BFFs que ainda exigem.
const bffKey = process.env.REACT_APP_BFF_KEY || process.env.BFF_KEY

 const httpLink = createHttpLink({
  uri:
    process.env.REACT_APP_BFF_ENDPOINT ||
    process.env.BFF_ENDPOINT ||
    'https://api-zelas.hubchat.com.br'
})

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      origin: process.env.REACT_APP_SITE_ORIGIN || 'https://saude.hubchat.com.br',
      ...(bffKey ? { authorization: bffKey } : ({} as Record<string, string>))
    }
  }
})

export default new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
})
